export enum EnumModalPosition{
    Top="top",
    Bottom="bottom",
    Left="left",
    Right="right",
    Center="center"
}